import React, { useCallback, useState } from 'react';

import { Modal as AntdModal } from 'antd';

import { BrancheDto } from 'lib_api/lib/api/gen';

import { useGFFilterContext } from 'hooks/GFFilterStoreContext';
import { useRefBrancheNature } from 'hooks/referentiels/useRefBrancheNature';

import Creation from '../../../Dossier/Creation';

import CreateDossierButton from './CreateDossierButton';

import './CreateDossier.less';

function CreateDossier(): React.ReactElement {
  const [branche, setBranche] = useState<BrancheDto>();
  const [, setfilters] = useGFFilterContext();
  const natures = useRefBrancheNature();

  const handleClosure = useCallback(() => {
    setBranche(undefined);
    setfilters(filters => {
      return {
        ...filters,
      };
    });
  }, [setBranche, setfilters]);

  return (
    <>
      <CreateDossierButton
        listBranches={natures ? natures.referenceDtoList : []}
        onClick={setBranche}
      />

      <AntdModal
        title={
          <div className={'centered'}>
            Créer une nouvelle fiche véhicule - {branche?.nature}
          </div>
        }
        open={!!branche}
        onCancel={() => setBranche(undefined)}
        destroyOnClose={true}
        width={'55%'}
        footer={null}
        maskClosable={false}
      >
        <Creation callAfterSubmit={handleClosure} branche={branche} />
      </AntdModal>
    </>
  );
}

export default CreateDossier;
